module.exports = __webpack_public_path__ + "static/media/m-brochure.36072e7c.pdf";